import * as Moment from 'dayjs';

export function setList () {
  const tableCols = [
    {
      title: '退货申请单号',
      dataIndex: 'outRefundCode',
      key: 'outRefundCode',
      width: 250,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '退货收货状态',
      dataIndex: 'receiveStatus',
      key: 'receiveStatus',
      width: 250,
      ellipsis: true,
      customRender: text => {
        return text === 1 ? '待收货' : text === 2 ? '部分收货' : text === 3 ? '已收货' : '--';
      },
    },
    {
      title: '客户名称',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 300,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '退货时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 200,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '销售单号',
      dataIndex: 'orderCode',
      key: 'orderCode',
      width: 200,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '退货仓库',
      dataIndex: 'warehouseName',
      key: 'warehouseName',
      width: 200,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '发货类型',
      dataIndex: 'directFlagDesc',
      key: 'directFlagDesc',
      width: 800,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
  ];

  return tableCols;
}
